import { render, staticRenderFns } from "./PVSelect.vue?vue&type=template&id=22e8ea2c&scoped=true&"
import script from "./PVSelect.vue?vue&type=script&lang=js&"
export * from "./PVSelect.vue?vue&type=script&lang=js&"
import style0 from "./PVSelect.vue?vue&type=style&index=0&id=22e8ea2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e8ea2c",
  null
  
)

export default component.exports